import { ElementStore } from 'component/Carousel/store/ElementStore'

export function attachResize(element: ElementStore): () => void {
  const { main } = element

  const onResize = () => {
    element.onResize()
  }

  const observer = new ResizeObserver(() => {
    onResize()
  })

  window.addEventListener('resize', onResize)
  observer.observe(main)
  onResize()

  return () => {
    window.removeEventListener('resize', onResize)
    observer.unobserve(main)
  }
}
